var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_366_25574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7877 12.2237C23.4895 7.92545 16.5219 7.92545 12.2237 12.2237C7.92545 16.5219 7.92545 23.4895 12.2237 27.7877C16.5219 32.0859 23.4895 32.0859 27.7877 27.7877C32.0859 23.4895 32.0859 16.5219 27.7877 12.2237V12.2237ZM23.9419 23.9419C23.4329 24.4509 22.6072 24.4509 22.0982 23.9419L20.0057 21.8494L17.9131 23.9419C17.4041 24.4509 16.5784 24.4509 16.0694 23.9419C15.5604 23.4329 15.5604 22.6072 16.0694 22.0982L18.162 20.0057L16.0694 17.9131C15.5604 17.4041 15.5604 16.5784 16.0694 16.0694C16.5784 15.5604 17.4041 15.5604 17.9131 16.0694L20.0057 18.162L22.0982 16.0694C22.6072 15.5604 23.4329 15.5604 23.9419 16.0694C24.4509 16.5784 24.4509 17.4041 23.9419 17.9131L21.8494 20.0057L23.9419 22.0982C24.4509 22.6072 24.4509 23.4329 23.9419 23.9419V23.9419Z",
    fill: "#000000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_366_25574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "black",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBlack);
export default __webpack_public_path__ + "static/media/error-black.b6b04131de4855572662336d495766de.svg";
export { ForwardRef as ReactComponent };